import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const UserManagementProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `User/v3/${props.userId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        const url = 'User/GetActiveUsersWithFranchiseUserRoles';
        const queryString = createQueryString(props);

        await execute({ scope: 'list', url: url + queryString, method: 'GET', secure: true });
    }, [execute]);  

    const searchRecords = useCallback(async (props) => {
        const url = 'User/v2';
        const queryString = createQueryString(props);

        await execute({ scope: 'search', url: url + queryString, method: 'GET', secure: true });
    }, [execute]);  

    const updateUserRolesRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseRoles/AssignRolesToUser/`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const listUserRoleRecords = useCallback(async (props) => {
        await execute({ scope: 'listuserroles', url: `FranchiseRoles/GetRolesByUser/${props.userId}`, method: 'GET', secure: true });
    }, [execute]);

    const createQueryString = (props) => {
        if (!_.isEmpty(props)) {
            return `?` + Object.keys(props).map(key => key + '=' + props[key]).join('&');
        }
    };

    const value = { listRecords, selectRecord, searchRecords, updateUserRolesRecord, listUserRoleRecords, newRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useUserManagementStore = () => React.useContext(Context);
